module.exports = __webpack_public_path__ + "img/4.3a6b5835.jpg";